import { Pipe, PipeTransform } from '@angular/core';
import { LimitedTermDuration } from '@platform-frontend/checkout-drop-in';
import { LicenseValidityDuration } from '../model/license-validity-context';

@Pipe({
  name: 'licenseValidityEndDate'
})
export class LicenseValidityEndDatePipe implements PipeTransform {
  transform(date: Date | null, duration: LicenseValidityDuration | null): Date | null {
    if (!date || !duration) {
      return null;
    }

    if (duration instanceof Date) {
      return duration;
    }

    if (!this.isValidDurationObject(duration)) {
      return null;
    }

    return this.addDurationToDate(date, duration);
  }

  private isValidDurationObject(duration: LicenseValidityDuration): duration is LimitedTermDuration {
    return (
      typeof duration === 'object' && 'runtime' in duration && 'unit' in duration && typeof duration.runtime === 'number' && typeof duration.unit === 'string'
    );
  }

  private addDurationToDate(date: Date, duration: LimitedTermDuration): Date | null {
    const newDate = new Date(date);

    switch (duration.unit) {
      case 'HOUR':
        newDate.setHours(newDate.getHours() + duration.runtime);
        break;
      case 'MINUTE':
        newDate.setMinutes(newDate.getMinutes() + duration.runtime);
        break;
      case 'DAY':
        newDate.setDate(newDate.getDate() + duration.runtime);
        break;
      case 'WEEK':
        newDate.setDate(newDate.getDate() + duration.runtime * 7);
        break;
      case 'MONTH':
        newDate.setMonth(newDate.getMonth() + duration.runtime);
        break;
      case 'YEAR':
        newDate.setFullYear(newDate.getFullYear() + duration.runtime);
        break;
      default:
        return null;
    }

    return newDate;
  }
}
